import { render, staticRenderFns } from "./Divisions.vue?vue&type=template&id=4a9da67a&"
import script from "./Divisions.vue?vue&type=script&lang=js&"
export * from "./Divisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports